import { getStringValue } from 'utilities/getStringValue';

const getSlugValue = (slug: string | null | undefined): string =>
  getStringValue(slug?.toLowerCase()?.replace(/\s/g, '-'));

export default getSlugValue;
